import { render, staticRenderFns } from "./MenuUserWidget.vue?vue&type=template&id=295f985a&scoped=true"
import script from "./MenuUserWidget.vue?vue&type=script&lang=js"
export * from "./MenuUserWidget.vue?vue&type=script&lang=js"
import style0 from "./MenuUserWidget.vue?vue&type=style&index=0&id=295f985a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295f985a",
  null
  
)

export default component.exports